import { render } from "./Gallery.vue?vue&type=template&id=b234e19e&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=b234e19e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\bert\\Documents\\Projects\\car-status\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b234e19e"]])

export default __exports__